import {
  FETCH_ZONES,
  FETCH_ZONES_SUCCESS,
  FETCH_ZONES_ERROR,
  FETCH_ZONE_BY_ID,
  FETCH_ZONE_BY_ID_SUCCESS,
  FETCH_ZONE_BY_ID_ERROR,
  CREATE_ZONE,
  CREATE_ZONE_SUCCESS,
  CREATE_ZONE_ERROR,
  UPDATE_ZONE,
  UPDATE_ZONE_SUCCESS,
  UPDATE_ZONE_ERROR,
  DELETE_ZONE,
  DELETE_ZONE_SUCCESS,
  DELETE_ZONE_ERROR,
  FETCH_ZONE_LOTS,
  FETCH_ZONE_LOTS_SUCCESS,
  FETCH_ZONE_LOTS_ERROR,
  FETCH_LOT_ZONES,
  FETCH_LOT_ZONES_SUCCESS,
  FETCH_LOT_ZONES_ERROR,
  ATTACH_ZONE_TO_LOT,
  ATTACH_ZONE_TO_LOT_SUCCESS,
  ATTACH_ZONE_TO_LOT_ERROR,
  UNLINK_ZONE_FROM_LOT,
  UNLINK_ZONE_FROM_LOT_SUCCESS,
  UNLINK_ZONE_FROM_LOT_ERROR,
} from './types';

const initialState = {
  zones: [],
  selectedZone: null,
  lotsForZone: [],
  lotZones: [],
  loading: {
    fetch: false,
    fetchById: false,
    create: false,
    update: false,
    delete: false,
    fetchZoneLots: false,
    fetchLotZones: false,
    attachZone: false,
    unlinkZone: false,
  },
  error: null,
};

const parkingZonesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_ZONES:
      return { ...state, loading: { ...state.loading, fetch: true }, error: null };
    case FETCH_ZONES_SUCCESS:
      return { ...state, zones: payload, loading: { ...state.loading, fetch: false } };
    case FETCH_ZONES_ERROR:
      return { ...state, loading: { ...state.loading, fetch: false }, error: 'Failed to fetch zones' };

    case FETCH_ZONE_BY_ID:
      return { ...state, loading: { ...state.loading, fetchById: true }, error: null };
    case FETCH_ZONE_BY_ID_SUCCESS:
      return { ...state, selectedZone: payload, loading: { ...state.loading, fetchById: false } };
    case FETCH_ZONE_BY_ID_ERROR:
      return { ...state, loading: { ...state.loading, fetchById: false }, error: 'Failed to fetch zone' };

    case CREATE_ZONE:
      return { ...state, loading: { ...state.loading, create: true }, error: null };
    case CREATE_ZONE_SUCCESS:
      return {
        ...state,
        zones: [...state.zones, payload],
        loading: { ...state.loading, create: false },
      };
    case CREATE_ZONE_ERROR:
      return { ...state, loading: { ...state.loading, create: false }, error: 'Failed to create zone' };

    case UPDATE_ZONE:
      return { ...state, loading: { ...state.loading, update: true }, error: null };
    case UPDATE_ZONE_SUCCESS:
      return {
        ...state,
        zones: state.zones.map((z) =>
          z.parkingZoneId === payload.parkingZoneId ? payload : z
        ),
        selectedZone: payload,
        loading: { ...state.loading, update: false },
      };
    case UPDATE_ZONE_ERROR:
      return { ...state, loading: { ...state.loading, update: false }, error: 'Failed to update zone' };

    case DELETE_ZONE:
      return { ...state, loading: { ...state.loading, delete: true }, error: null };
    case DELETE_ZONE_SUCCESS:
      return {
        ...state,
        zones: state.zones.filter((z) => z.parkingZoneId !== payload),
        selectedZone: state.selectedZone?.parkingZoneId === payload ? null : state.selectedZone,
        loading: { ...state.loading, delete: false },
      };
    case DELETE_ZONE_ERROR:
      return { ...state, loading: { ...state.loading, delete: false }, error: 'Failed to delete zone' };

    case FETCH_ZONE_LOTS:
      return { ...state, loading: { ...state.loading, fetchZoneLots: true }, error: null };
    case FETCH_ZONE_LOTS_SUCCESS:
      return { ...state, lotsForZone: payload, loading: { ...state.loading, fetchZoneLots: false } };
    case FETCH_ZONE_LOTS_ERROR:
      return { ...state, loading: { ...state.loading, fetchZoneLots: false }, error: 'Failed to fetch lots for zone' };

    case FETCH_LOT_ZONES:
      return { ...state, loading: { ...state.loading, fetchLotZones: true }, error: null };
    case FETCH_LOT_ZONES_SUCCESS:
      return { ...state, lotZones: payload, loading: { ...state.loading, fetchLotZones: false } };
    case FETCH_LOT_ZONES_ERROR:
      return { ...state, loading: { ...state.loading, fetchLotZones: false }, error: 'Failed to fetch zones for lot' };

    case ATTACH_ZONE_TO_LOT:
      return { ...state, loading: { ...state.loading, attachZone: true }, error: null };
    case ATTACH_ZONE_TO_LOT_SUCCESS:
      return { ...state, loading: { ...state.loading, attachZone: false } };
    case ATTACH_ZONE_TO_LOT_ERROR:
      return { ...state, loading: { ...state.loading, attachZone: false }, error: 'Failed to attach zone to lot' };

    case UNLINK_ZONE_FROM_LOT:
      return { ...state, loading: { ...state.loading, unlinkZone: true }, error: null };
    case UNLINK_ZONE_FROM_LOT_SUCCESS:
      return {
        ...state,
        lotZones: state.lotZones.filter(
          (z) => z.parkingZoneId !== payload.zoneId
        ),
        loading: { ...state.loading, unlinkZone: false },
      };
    case UNLINK_ZONE_FROM_LOT_ERROR:
      return { ...state, loading: { ...state.loading, unlinkZone: false }, error: 'Failed to unlink zone from lot' };

    default:
      return state;
  }
};

export default parkingZonesReducer;
